module.exports = __webpack_public_path__ + "img/image7.37de41d7.png";